"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _recompose = require("recompose");

var _contextMenu = require("../components/contextMenu");

var _contextMenu2 = _interopRequireDefault(_contextMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// --------------------------------------------------

var defaultOpts = [{
	label: "noop",
	fn: function fn() {}
}];

var withContextMenu = (0, _recompose.compose)((0, _recompose.withState)("contextMeta", "setContextMeta", {
	x: 0,
	y: 0,
	isOpen: false
}), (0, _recompose.withHandlers)({
	onContextMenu: function onContextMenu(_ref) {
		var setContextMeta = _ref.setContextMeta;
		return function (e) {
			var x = e.clientX,
			    y = e.clientY;

			setContextMeta(function () {
				return {
					x: x,
					y: y,
					isOpen: true
				};
			});
			e.stopPropagation();
			e.preventDefault();
		};
	},
	closeContextMenu: function closeContextMenu(_ref2) {
		var setContextMeta = _ref2.setContextMeta;
		return function () {
			return setContextMeta(R.assoc("isOpen", false));
		};
	}
}),
// options are set through props rather than as an arg of withContextMenu
// to let you do your own memoizing using withPropsOnChange, instead of calling
// a function on every single render (eg, if it were: "options = { createOptions(props) }")
(0, _recompose.withPropsOnChange)(["children", "contextMeta", "contextMenuOptions"], function (props) {
	return {
		children: props.contextMeta.isOpen ? _react2.default.Children.toArray(props.children).concat(_react2.default.createElement(_contextMenu2.default, {
			x: props.contextMeta.x,
			y: props.contextMeta.y,
			options: props.contextMenuOptions || props.cmOptions || defaultOpts,
			close: props.closeContextMenu,
			key: "context-menu"
		})) : props.children,
		ContextMenu: function ContextMenu() {
			return props.contextMeta.isOpen ? _react2.default.createElement(_contextMenu2.default, {
				x: props.contextMeta.x,
				y: props.contextMeta.y,
				options: props.contextMenuOptions || props.cmOptions || defaultOpts,
				close: props.closeContextMenu,
				key: "context-menu"
			}) : null;
		}
	};
}));

exports.default = withContextMenu;

//# sourceMappingURL=withContextMenu.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/enhancers/withContextMenu.js
// module id = 385
// module chunks = 0